import { render, staticRenderFns } from "./PrinterPage.vue?vue&type=template&id=23a6f079"
import script from "./PrinterPage.vue?vue&type=script&lang=js"
export * from "./PrinterPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports